export default __webpack_public_path__ + "static/map-body-responsive-cc95fee0bb293b09681f72ccfb65c24a.png";